module.exports = __webpack_public_path__ + "static/images/inbox.cc3de70d750703d7c89d16823b2e1ef0.svg";